import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useDebouncedCallback } from 'use-debounce';
import {
  addSearchParams,
  deleteSearchParams,
} from '@/utils/handle-search-param.ts';

export const useSearchInputWithQuery = ({
  defaultValue,
  searchParamsToDelete,
}: {
  defaultValue?: string;
  searchParamsToDelete?: string[];
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = useState(defaultValue || '');

  const debouncedUpdateSearchParams = useDebouncedCallback((query) => {
    if (query) {
      setSearchParams((prev) => {
        addSearchParams(prev, [{ name: 'q', value: query }]);
        if (searchParamsToDelete)
          deleteSearchParams(prev, searchParamsToDelete);
        return prev;
      });
    } else {
      setSearchParams(
        deleteSearchParams(
          searchParams,
          searchParamsToDelete ? ['q', ...searchParamsToDelete] : ['q'],
        ),
      );
    }
  }, 200);

  const onValueChange = useCallback(
    (value?: string) => {
      const query = value || '';
      setValue(query);
      debouncedUpdateSearchParams(query);
    },
    [debouncedUpdateSearchParams],
  );

  return {
    value,
    onValueChange,
  };
};
